import React from "react";
import { GiRadioTower } from "react-icons/gi";

type CampainDetailsProps = {
	description: string;
	amountCollected: Number;
	targetAmount: Number;
};

export default function CampainCardDetails({
	description,
	amountCollected,
	targetAmount
}: CampainDetailsProps) {
	return (
		<div className="flex flex-col mr-3 gap-1 mt-5">
			<div className="text-sm text-gray-700 mb-2 line-clamp-2">
				{description}
			</div>
			<div className="mt-2 mb-2">
				<div className="text-xs text-gray-500">Impact made</div>
				<div className="flex items-center text-primary-100 font-bold text-lg">
					<span className="mr-1">🪙</span>
					{amountCollected.toString()} bars
				</div>
			</div>
			<div className="w-full h-2 bg-gray-200 rounded mt-2 mb-2">
				<div
					className="h-2 bg-primary-100 rounded"
					style={{
						width: `${Math.min(
							(Number(amountCollected) / Number(targetAmount)) *
								100 || 0,
							100,
						)}%`,
					}}
				></div>
			</div>
			<div className="flex justify-between text-xs text-gray-700 font-semibold">
				<div>
					{amountCollected.toString()}
					<br />
					<span className="font-normal">Bars donated</span>
				</div>
				<div className="text-right">
					{targetAmount.toString()}
					<br />
					<span className="font-normal">Goal</span>
				</div>
			</div>
		</div>
	);
}
